export function saveErrorLog(obj) {
  // console.log(obj.response);
  if (!obj.client_message) {
    obj['client_message'] = '';
  }

  const msg = {
    time: new Date(),
    status: obj.response.status,
  };

  if (obj.response.config) {
    msg['request_payload'] = obj.response.config.data;
  }

  if (!obj.client_message.response) {
    msg['client_message'] = obj.client_message;
  }

  if (obj.response) {
    msg['data'] = obj.response.data;
    msg['url'] = `[${obj.config.method}] ${obj.response.config.url}`;
  }

  return msg;
}
